import { useEffect, useState } from 'react';
import { Routes, Route, Navigate, NavLink, useNavigate } from 'react-router-dom';
import { sysApi, getSysToken, clearSysToken } from './api/sysadmin';
import SysAdminLoginPage from './pages/SysAdminLoginPage';
import SysAdminUsersPage from './pages/SysAdminUsersPage';
import SysAdminAssetsPage from './pages/SysAdminAssetsPage';

export default function SysAdminApp() {
  const [user, setUser] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const token = getSysToken();
    if (!token) { setLoading(false); return; }
    sysApi.me()
      .then(r => setUser(r.user))
      .catch(() => { clearSysToken(); setUser(null); })
      .finally(() => setLoading(false));
  }, []);

  async function logout() {
    try { await sysApi.logout(); } catch { /* ignore */ }
    clearSysToken();
    setUser(null);
    navigate('/sys/login', { replace: true });
  }

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <span className="spinner" />
      </div>
    );
  }

  if (!user) {
    return (
      <Routes>
        <Route path="/sys/login" element={<SysAdminLoginPage onLogin={setUser} />} />
        <Route path="/sys/*" element={<Navigate to="/sys/login" replace />} />
      </Routes>
    );
  }

  return (
    <>
      <nav className="bottom-nav nav-3">
        <NavLink to="/sys" end className={({ isActive }) => isActive ? 'active' : ''}>
          <span className="bottom-nav-icon">👥</span>用户
        </NavLink>
        <NavLink to="/sys/assets" className={({ isActive }) => isActive ? 'active' : ''}>
          <span className="bottom-nav-icon">🖼️</span>资源
        </NavLink>
        <button
          className="bottom-nav-button"
          onClick={logout}
          style={{
            background: 'none', border: 'none', cursor: 'pointer',
            color: 'inherit', font: 'inherit',
            display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2,
            padding: 0,
          }}
        >
          <span className="bottom-nav-icon">🚪</span>退出
        </button>
      </nav>

      <Routes>
        <Route path="/sys" element={<SysAdminUsersPage />} />
        <Route path="/sys/assets" element={<SysAdminAssetsPage />} />
        <Route path="/sys/login" element={<Navigate to="/sys" replace />} />
        <Route path="/sys/*" element={<Navigate to="/sys" replace />} />
      </Routes>
    </>
  );
}
